export default __webpack_public_path__ + "static/media/articleimage.73a1bc1c.png";